(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-ove-article]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const prose = root.querySelector('[data-ove-prose]');
      const toc = root.querySelector('[data-ove-toc]');
      const nav = root.querySelector('[data-ove-toc-links]');
      const headings = prose.querySelectorAll('h2');
      if (!headings.length) { root.querySelector('.ove-reading').style.gridTemplateColumns = 'minmax(0,740px)'; return; }
      headings.forEach((heading, index) => {
        if (!heading.id) {
          let id = `ove-heading-${index + 1}`;
          while (document.getElementById(id)) id += '-section';
          heading.id = id;
        }
        const link = document.createElement('a');
        link.href = '#' + encodeURIComponent(heading.id);
        link.textContent = heading.textContent.trim();
        nav.append(link);
      });
      toc.hidden = false;
      toc.open = !matchMedia('(max-width:749px)').matches;
      if (typeof IntersectionObserver !== 'undefined') {
        const observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            nav.querySelectorAll('a').forEach(link => {
              if (link.hash === '#' + encodeURIComponent(entry.target.id)) link.setAttribute('aria-current', 'true');
              else link.removeAttribute('aria-current');
            });
          });
        }, { rootMargin: '-15% 0px -65% 0px' });
        headings.forEach(heading => observer.observe(heading));
        document.addEventListener('shopify:section:unload', event => { if (event.target.contains(root)) observer.disconnect(); });
      }
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
